import React from 'react'

const Report = () => {
  return (
    <div className='w-full h-[calc(90vh-2.4rem)] bg-white rounded-xl shadow-lg flex flex-col items-center justify-center'>
      These are our Report
    </div>
  )
}

export default Report
